import { memo } from 'react'
import { Heading, Paragraph, SearchIcon } from '@quickmd-llc/design-system'
import { text } from '../constants'

type Props = {
  /** The active search query. When present, renders the "no matches" state. */
  searchQuery?: string
}

function ChartsPlaceholder({ searchQuery }: Props) {
  const isSearching = Boolean(searchQuery)
  const title = isSearching ? `No charts match “${searchQuery}”` : text.SEARCH_PROMPT_TITLE
  const subtitle = isSearching ? text.NO_RESULTS_SUBTITLE : text.SEARCH_PROMPT_SUBTITLE

  return (
    <div className='flex h-full flex-col items-center justify-center gap-sp-1 px-sp-2 py-sp-8 text-center'>
      <div className='flex h-16 w-16 items-center justify-center rounded-full bg-deep-navy-20'>
        <SearchIcon iconSize='l' className='text-text-light' />
      </div>

      <Heading level='h3'>{title}</Heading>

      <Paragraph size='sm' className='text-text-medium'>
        {subtitle}
      </Paragraph>
    </div>
  )
}

export default memo(ChartsPlaceholder)
